import React from "react";

const WhyChooseUsOne = () => {
  return (
    <div className="wcu-area-1 space-bottom mt-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6">
            <div className="title-area text-center">
              <span className="sub-title">What we do</span>
              <h2 className="sec-title">
                Comprehensive Auto Solutions for Every Journey{" "}
                <img
                  className="title-bg-shape shape-center"
                  src="assets/img/bg/title-bg-shape.png"
                  alt="Silverline"
                />
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row gy-40 gx-60 align-items-center">
          <div className="col-xl-4 order-xl-2">
            <div className="wcu-thumb-1">
              <img src="assets/img/normal/thumb.jpg" alt="Silverline" />
            </div>
          </div>
          <div className="col-xl-4 col-md-6 order-xl-1">
            <div className="wcu-card-wrap right-wrap">
              <div className="wcu-card">
                <div className="icon">
                  <img src="assets/img/icon/wcu-icon_2-1.svg" alt="" />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Auto Fixers</h4>
                  <p className="wcu-card-text">
                    Providing expert car repair and diagnostics to fix
                    mechanical and electrical issues.{" "}
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img
                    src="assets/img/icon/wcu-icon_2-2.svg"
                    alt="Silverline"
                  />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Mechanic Masters</h4>
                  <p className="wcu-card-text">
                    Experienced professionals delivering high-quality mechanical
                    and electrical repairs for all vehicle types.{" "}
                  </p>
                </div>
              </div>
              <div className="wcu-card">
                <div className="icon">
                  <img
                    src="assets/img/icon/wcu-icon_2-3.svg"
                    alt="Silverline"
                  />
                </div>
                <div className="wcu-card-details">
                  <h4 className="wcu-card-title">Car Care Clinic</h4>
                  <p className="wcu-card-text">
                    Comprehensive vehicle maintenance and servicing, keeping
                    your car in excellent condition for long-lasting performance
                    and reliability.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-6 order-xl-3">
            <div className="wcu-card">
              <div className="icon">
                <img src="assets/img/icon/wcu-icon_2-4.svg" alt="Silverline" />
              </div>
              <div className="wcu-card-details">
                <h4 className="wcu-card-title">Smart Car Exchange</h4>
                <p className="wcu-card-text">
                  Seamless car buying, selling, and trade-in services designed
                  to offer convenience and great value for every customer.{" "}
                </p>
              </div>
            </div>
            <div className="wcu-card">
              <div className="icon">
                <img src="assets/img/icon/wcu-icon_2-5.svg" alt="Silverline" />
              </div>
              <div className="wcu-card-details">
                <h4 className="wcu-card-title">Trusted Auto Buyers</h4>
                <p className="wcu-card-text">
                  Providing instant car evaluations and competitive offers,
                  making selling your vehicle easy, transparent, and
                  stress-free.{" "}
                </p>
              </div>
            </div>
            <div className="wcu-card">
              <div className="icon">
                <img src="assets/img/icon/wcu-icon_2-6.svg" alt="Silverline" />
              </div>
              <div className="wcu-card-details">
                <h4 className="wcu-card-title">Luxury Rides Hub</h4>
                <p className="wcu-card-text">
                  High-end vehicle sales featuring premium cars with top-tier
                  quality, ensuring a luxurious driving experience.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUsOne;
